import { useState } from 'react';

export default function SubscribeCTA() {
  const [email, setEmail] = useState('');

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    const form = e.target as HTMLFormElement;
    const honeypot = (form.querySelector('[name="website_alt"]') as HTMLInputElement)?.value?.trim();
    if (honeypot) {
      setEmail('');
      return;
    }
    const formData = new FormData(form);
    const params = new URLSearchParams();
    formData.forEach((value, key) => {
      if (key !== 'website_alt') params.append(key, value as string);
    });

    fetch('https://readdy.ai/api/form/d90ha2s6ci2plld1odk0', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: params.toString(),
    })
      .then(() => {
        setEmail('');
        alert('订阅成功！每日早8点准时推送最新爆料！');
      })
      .catch(() => {
        alert('订阅失败，请稍后再试～');
      });
  };

  return (
    <section className="relative py-20 md:py-28 px-4 md:px-8 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Neon%20city%20nightscape%20with%20pink%20and%20magenta%20glowing%20signs%2C%20futuristic%20urban%20skyline%2C%20cyberpunk%20aesthetic%2C%20dark%20moody%20atmosphere%2C%20wet%20streets%20reflecting%20neon%20lights%2C%20cinematic%20wide%20shot%2C%20dramatic%20contrast%2C%20vignette%20edges&width=1920&height=900&seq=cta-bg-neon-city&orientation=landscape"
          alt="订阅吃瓜日报背景"
          title="不错过任何一个瓜 - 订阅爆料专区每日推送"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-foreground-950/60" />
        <div className="absolute inset-0 bg-gradient-radial from-transparent via-foreground-950/40 to-foreground-950/80" />
      </div>

      <div className="relative max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-8">
          <div className="lg:max-w-lg">
            <h2 className="text-4xl md:text-5xl lg:text-6xl xl:text-7xl font-heading font-black text-background-50 leading-[1.1] tracking-tight">
              不错过
              <br />
              任何一个瓜
            </h2>
          </div>

          <div className="lg:text-right lg:max-w-md">
            <p className="text-sm md:text-base text-background-50/70 leading-relaxed">
              每日早8点更新推送，覆盖网红黑料、明星八卦与社会热点，直接送达你的订阅箱
            </p>
          </div>
        </div>

        <div className="mt-12 md:mt-16">
          <form
            data-readdy-form
            id="subscribe-form"
            onSubmit={handleSubmit}
            className="flex flex-col sm:flex-row items-start sm:items-center gap-3 max-w-md"
          >
            <div className="flex-1 w-full">
              <input
                type="email"
                name="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="输入你的邮箱地址"
                required
                className="w-full px-5 py-3.5 bg-background-50/10 backdrop-blur-sm border border-background-50/20 rounded-full text-background-50 text-sm placeholder:text-background-50/40 outline-none focus:border-background-50/50 transition-colors"
              />
            </div>
            <input
              type="text"
              name="website_alt"
              tabIndex={-1}
              autoComplete="off"
              aria-hidden="true"
              className="absolute opacity-0 pointer-events-none"
            />
            <button
              type="submit"
              className="group flex items-center gap-3 px-6 py-3.5 bg-background-50 text-foreground-950 text-sm font-semibold rounded-full hover:bg-background-100 transition-all whitespace-nowrap cursor-pointer"
            >
              订阅吃瓜日报
              <span className="w-7 h-7 rounded-full bg-foreground-950 flex items-center justify-center group-hover:translate-x-1 transition-transform">
                <i className="ri-arrow-right-line text-background-50 text-sm"></i>
              </span>
            </button>
          </form>
        </div>
      </div>
    </section>
  );
}